module.exports = __webpack_public_path__ + "img/hand-draw-map-dyz-2.4ac9180d.png";